import type { PendingFindFilters } from "../../routes/find-route";
import { BreedCarousel, type PopularBreed } from "./BreedCarousel";
import { BreedCollections } from "./BreedCollections";
import { useCollectionCounts } from "./useCollectionCounts";

export function BrowseZone({
    onSelectCollection,
    location,
    enableCounts = false,
    breeds,
    onSelectBreed,
    onSearchAll,
}: {
    onSelectCollection: (id: string, filters: PendingFindFilters) => void;

    location?: { lat: number; lng: number } | null;

    enableCounts?: boolean;
    breeds: PopularBreed[];
    onSelectBreed: (breedId: string) => void;

    onSearchAll?: () => void;
}) {
    const collectionCounts = useCollectionCounts(
        location ?? null,
        enableCounts,
    );

    return (
        <div className="flex w-full flex-col gap-8">
            <BreedCollections
                onSelect={onSelectCollection}
                counts={collectionCounts}
            />
            <BreedCarousel
                breeds={breeds}
                onSelect={onSelectBreed}
                onSearchAll={onSearchAll}
            />
        </div>
    );
}
